import isEmpty from '../../../Shared/Utils/isEmpty';

const subscribeToConcurrencyApiResponse = (
    concurrencyApiResponse$,
    concurrencyStore,
) =>
    concurrencyApiResponse$
        .subscribe(concurrencyResponse => {
            const updateResponse = concurrencyResponse && concurrencyResponse.updateResponse;

            if (
                isEmpty(updateResponse) ||
                !updateResponse.id ||
                !updateResponse.encryptedLock ||
                !updateResponse.sequenceToken
            )  {
                return concurrencyStore.actions.disableFeature();
            }

            const {
                id,
                encryptedLock,
                sequenceToken,
            } = concurrencyResponse.updateResponse;

            concurrencyStore.actions.updateConcurrency({
                encryptedLock,
                sequenceToken,
                lockId: id,
            });
        });

export default subscribeToConcurrencyApiResponse;
